export default __webpack_public_path__ + "static/media/choices-icon.195320b0.svg";